var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6888_15748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6888_15748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50059 11.2294C9.40059 11.2294 9.30371 11.2106 9.20996 11.1731C9.11621 11.1356 9.03809 11.0856 8.97559 11.0231L5.52559 7.57311C5.38809 7.43561 5.31934 7.26061 5.31934 7.04811C5.31934 6.83561 5.38809 6.66061 5.52559 6.52311C5.66309 6.38561 5.83809 6.31686 6.05059 6.31686C6.26309 6.31686 6.43809 6.38561 6.57559 6.52311L9.50059 9.44811L12.4256 6.52311C12.5631 6.38561 12.7381 6.31686 12.9506 6.31686C13.1631 6.31686 13.3381 6.38561 13.4756 6.52311C13.6131 6.66061 13.6818 6.83561 13.6818 7.04811C13.6818 7.26061 13.6131 7.43561 13.4756 7.57311L10.0256 11.0231C9.95059 11.0981 9.86934 11.1512 9.78184 11.1825C9.69434 11.2137 9.60059 11.2294 9.50059 11.2294Z",
    fill: "#864BFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.d385064333c149b9dfb7b459ba765c9c.svg";
export { ForwardRef as ReactComponent };